import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceRemoveTaskState = createStateReducer(initialState, {
  [events.removeTaskSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeTask",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.removeTaskFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeTask",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceRemoveTaskState };
